import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";
import { useEffect, useState } from "react";
import ApiService from "../../../core/service/api-service";
import DataGrid from "../../../core/components/data-grid/DataGrid";
import worklistItemColumns from "./WorklistItemColumns";
import { useTranslation } from "react-i18next";
import { Button, notification, Space } from "antd";
import { useModal } from "../../../core/context/ModalContext";
import WorklistItemBulkScheduleModal from "../WorklistItemBulkScheduleModal";
import { set } from "lodash";
import WorklistItemCreateEdit from '../WorklistItemCreateEdit';
import { useUser } from "../../../core/context/UserContext";
import AppointmentDetails from "../../appointment/AppointmentDetails";

export default function WorklistItemGrid() {
    const { t } = useTranslation();
    const { setData, setPaginationResult, queryModel, setDataGridProps, selectedRows, selectedRowKeys, setSelectedRows, refreshDataGrid } = useDataGrid();
    const { openModal, closeModal } = useModal();
    const { hasPermission } = useUser();

    const handleNewWorklistItem = () => {
        openModal(t('New Worklist Item'), (
            <WorklistItemCreateEdit
                onSaved={() => {
                    closeModal();
                    refreshDataGrid();
                }}
            />
        ));
    }

    const openAppointmentModal = async (worklistItem) => {
        const res = await ApiService.Appointment.GetById(worklistItem?.appointment.id);
        const appointment = res?.data

        openModal(t('Appointment Details'), (
            <AppointmentDetails
                appointmentId={appointment.id}
                onStatusChange={async (newStatus) => {
                    refreshDataGrid();
                }}
                onRemove={() => {
                    refreshDataGrid();
                }}
            />
        ))
    }

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            virtual: true,
            columns: worklistItemColumns(t, hasPermission, getWorklistItemGrid, handleBulkSchedule, openAppointmentModal),
            enableRowSelection: true,
        })
    }, [selectedRowKeys])

    const getWorklistItemGrid = async () => {
        const response = await ApiService.WorklistItem.GetDataGrid(queryModel);
        if (response.success) {
            setData(response.data);
            setPaginationResult(response.pagination)
        }
    }

    useEffect(() => {
        getWorklistItemGrid()
    }, [queryModel.updateKey])

    const handleBulkSchedule = (items = []) => {
        if (items.length === 0) {
            return;
        }

        const first = items[0];
        for (let i = 1; i < items.length; i++) {
            if (items[i].patientId !== first.patientId) {
                notification.error({
                    message: t('Bulk Scheduling Error'),
                    description: t('Please select worklist items from the same patient for bulk scheduling.'),
                });
                return;
            }

            if (items[i].modality?.id !== first.modality?.id) {
                notification.error({
                    message: t('Bulk Scheduling Error'),
                    description: t('Please select worklist items from the same modality for bulk scheduling.'),
                });
                return;
            }
        }

        openModal(t('Bulk Schedule Worklist Items'), (
            <WorklistItemBulkScheduleModal
                onCancel={() => {
                    closeModal()
                    setSelectedRows([]);
                }}
                worklistItems={items}
                onSuccess={() => {
                    setSelectedRows([]);
                    getWorklistItemGrid();
                    closeModal();
                }}
            />
        ))
    }

    return (
        <>
            <DataGrid
                title={() => {
                    return (
                        <>
                            <Button onClick={handleNewWorklistItem} size='small'>
                                {t('New Worklist Item')}
                            </Button>
                            {selectedRows.length > 0 && (
                                <Space>
                                    <Button
                                        size="small"
                                        type="primary"
                                        onClick={() => {
                                            handleBulkSchedule(selectedRows)
                                        }}
                                    >
                                        {t('Schedule Selected')} ({selectedRows.length})
                                    </Button>
                                    <Button size="small" onClick={() => setSelectedRows([])}>
                                        {t('Clear Selection')}
                                    </Button>
                                </Space>
                            )}
                        </>
                    )
                }}
                name={'worklist-item'} />
        </>
    )
}
